import { Page } from '@/core/architecture'

import { WalletTemplate } from './template'
import { useViewModel } from './viewModel'

export const Wallet: Page = () => {
  const { state, actions } = useViewModel()

  return <WalletTemplate state={state} {...actions} />
}
